import React from 'react'

function Awards() {
  return (
    <div>Awards</div>
  )
}

export default Awards